import React from 'react';

import * as Styles from './AlertStyles';

import Text from '../../../../ui/Text';
import { IconError, IconWarning } from '../../../../ui/CardStatus';

interface AlertProps {
  type: 'warning' | 'danger' | 'none';
  error: string | null;
}

const Alert: React.FC<AlertProps> = ({ type, error }: AlertProps) => {
  if (type === 'none') return <></>;

  return (
    <Styles.Container type={type}>
      {type === 'danger' ? <IconError size={24} $notFlex /> : <IconWarning size={24} $notFlex />}
      <Styles.ContainerChildren>
        <Text scale="body1" color="black">
          {type === 'warning' ? 'Importante:' : 'Atenção:'}
        </Text>
        <Text scale="caption1" color="black80">
          {type === 'warning'
            ? `A Memed não armazenará o login e senha inseridos e não serão
          transmitidas informações de dispensações para SNGPC.`
            : error}
        </Text>
      </Styles.ContainerChildren>
    </Styles.Container>
  );
};

export default Alert;
